<mat-toolbar class="app-header mat-elevation-z3">
    <mat-toolbar-row>
        <div fxLayout="row" fxFill fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center">
                <a mat-button routerLink="/c">
                    <img alt="CER Manager logo" src="assets/logo.png" class="header-logo" appBusy>
                </a>
                <div class="cer-manager">{{ 'CER MANAGER'|i18n }}</div>
            </div>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
